import { Injectable } from '@angular/core';

@Injectable()
export class UtilityService {

  constructor() { }

  showTrackingOption(trackingOptions: any[], option: string, savedOption: any): boolean {
    if (savedOption) {
      if (savedOption[`${option}`]) {
        return trackingOptions?.some(track => track.code === option && track.enabled);
      } else {
        return false;
      }
    } else {
      return trackingOptions?.some(track => track.code === option && track.enabled);
    }
  }

  savedTrackingCols(trackingOptions: any[], option: string, savedOption: any): boolean {
    if (savedOption) {
      if (savedOption[`${option}`]) {
        return trackingOptions?.some(track => track.code === option && track.enabled);
      } else {
        return false;
      }
    } 
  }

  displayName(trackingOptions: any[], code, type) {
    if (type === 'label') {
      return trackingOptions?.find(opt => opt.code == code)?.name;
    } else if (type === 'currency') {
      return trackingOptions?.find(opt => opt.code == code)?.currencySymbol;
    } else {
      return trackingOptions?.find(opt => opt.code == code)?.formControlName;
    }
  }

  getDecimalValue(trackingOptions: any[], code) {
    return trackingOptions?.find(opt => opt.code == code)?.noOfDecimal;
  }

  isCountCategory(uomCategory: any[], categoryId: number): boolean {
    if (!Array.isArray(uomCategory) || uomCategory.length === 0) {
      return false;
    }
    const countCategoryExists = uomCategory.find(ct => ct.name === 'Count');
    return countCategoryExists && (countCategoryExists.id === categoryId);
  }

  getAvailableChildUOM<T>(list: T[], index: number) {
    if (!list[0]?.['unitOfMeasureId']?.['childUOM']) {
      return [];
    }
    const selectedIds = list?.filter((_, i) => i !== index)?.map(item => item['unitOfMeasureId']?.['id'])?.filter(id => id);
    return list[0]['unitOfMeasureId']['childUOM'].filter(uom => !selectedIds.includes(uom['id']));
  }

}
